import * as React from 'react';
import {useState} from 'react';
import {
    UitkIcon,
    UitkIconSize,
    UitkInput,
    UitkLayoutFlex,
    UitkLayoutFlexItem,
    UitkPrimaryButton,
    UitkSpacing,
    UitkTertiaryButton,
    UitkToast
} from "@egencia/uitk-react";

export function ShareArticle({ article, articleLink }) {
    const localizedShareArticle = uitk.i18n.msg('panel_share_article');
    const localizedCopyLink = uitk.i18n.msg('panel_copy_link');
    const localizedCopied = uitk.i18n.msg('panel_copy_success_message');
    
    const [showShareLink, setShowShareLink] = useState(false);
    const [showCopiedToast, setShowCopiedToast] = useState(false);
    
    function handleClickShareArticle() {
        const defaultTitle = article.defaultTitleForEmail.replace(/\?/g, '').split(' ').join('.');
        const shareArticleClicked = 'HelpCenter.Panel.ShareArticle.' + defaultTitle + '.Clicked';
        omnitureLog.logClickEvent(shareArticleClicked);
        
        setShowShareLink(true);
    }
    
    function handleCopyLink() {
        navigator.clipboard.writeText(articleLink);
        setShowCopiedToast(true);
    }
    
    return (
        <div>
            <UitkTertiaryButton type="button" onClick={handleClickShareArticle} id="btn-share-article">
                <UitkIcon name="share" />
                {localizedShareArticle}
            </UitkTertiaryButton>
           
            {showShareLink && (
                <UitkSpacing margin={{blockstart: "two"}}>
                    <UitkLayoutFlex space={"two"} direction={"column"}>
                        <UitkLayoutFlexItem grow={1}>
                            <UitkInput label={localizedCopyLink} value={articleLink} id="url-share-article"/>
                        </UitkLayoutFlexItem>
                        <UitkLayoutFlexItem grow={0}>
                            <UitkPrimaryButton onClick={handleCopyLink} id="copy-share-article">{localizedCopyLink}</UitkPrimaryButton>
                        </UitkLayoutFlexItem>
                    </UitkLayoutFlex>
                </UitkSpacing>
            )}
            
            <UitkToast
                show={showCopiedToast}
                onDismiss={() => setShowCopiedToast(false)}
            >
            <UitkSpacing padding={{inlineend: "one"}}>
                <UitkIcon name='check' size={UitkIconSize.XSMALL} />
            </UitkSpacing>
            { localizedCopied }
            </UitkToast> 
        </div>
    )
} 